//@ts-check

// @ts-ignore
let config = process.env;

// Runtime config from env-config.js (loaded via script tag in index.html)
// @ts-ignore
const runtimeConfig = (typeof window !== 'undefined' && window._env_) || {};

/**
 * @description Represents the appLinkSettings type
 *
 * @typedef {Object} appLinkSettingsType
 * @property {string|undefined} env
 * @property {string|undefined} OIDC_PROVIDER
 * @property {string|undefined} OIDC_CLIENT_ID
 * @property {string|undefined} OIDC_REDIRECT_ROUTE
 * @property {string|undefined} OIDC_END_SESSION_ENDPOINT
 * @property {string|undefined} API_BASE_URL
 * @property {string|undefined} APIM_BASE_URL
 * @property {string|undefined} OCP_APIM_SUBSCRIPTION_KEY
 * @property {string|undefined} INSTRUMENTATION_KEY
 * @property {string|undefined} WORKSPACE_ID
 * @property {string|undefined} INSIGHTS_APP_ID
 * @property {string|undefined} INSIGHTS_API_KEY
 * @property {string|undefined} HARNESSKEY
 */

/**
 * @description appSettings.json is the repo to access the env. variable. Based on the env. variable it
 * will produce the required appSettings configuration.
 *
 * @type {appLinkSettingsType}
 */
const appSettings = {
  env: "",
  OIDC_PROVIDER: "",
  OIDC_CLIENT_ID: "",
  OIDC_REDIRECT_ROUTE: "",
  OIDC_END_SESSION_ENDPOINT: "",
  API_BASE_URL: "",
  APIM_BASE_URL: "",
  OCP_APIM_SUBSCRIPTION_KEY: "",
  INSTRUMENTATION_KEY: "",
  WORKSPACE_ID: "",
  INSIGHTS_APP_ID: "",
  INSIGHTS_API_KEY: "",
  HARNESSKEY: "",
};

// DEV
if (config.REACT_APP_ENV === "DEV") {
  Object.assign(appSettings, {
    env: config.REACT_APP_ENV,
    OIDC_PROVIDER: config.REACT_APP_DEV_OIDC_PROVIDER,
    OIDC_CLIENT_ID: config.REACT_APP_DEV_OIDC_CLIENT_ID,
    OIDC_REDIRECT_ROUTE: config.REACT_APP_DEV_OIDC_REDIRECT_ROUTE,
    OIDC_END_SESSION_ENDPOINT: config.REACT_APP_DEV_OIDC_END_SESSION_ENDPOINT,
    API_BASE_URL: config.REACT_APP_DEV_API_BASE_URL,
    APIM_BASE_URL: config.REACT_APP_DEV_APIM_BASE_URL,
    OCP_APIM_SUBSCRIPTION_KEY: config.REACT_APP_DEV_OCP_APIM_SUBSCRIPTION_KEY,
    INSTRUMENTATION_KEY: config.REACT_APP_DEV_INSTRUMENTATION_KEY,
    WORKSPACE_ID: config.REACT_APP_DEV_WORKSPACE_ID,
    INSIGHTS_APP_ID: config.REACT_APP_DEV_INSIGHTS_APP_ID,
    INSIGHTS_API_KEY: config.REACT_APP_DEV_INSIGHTS_API_KEY,
    HARNESSKEY: config.REACT_APP_DEV_HARNESSKEY,
  });
}

// TEST
else if (config.REACT_APP_ENV === "TEST") {
  Object.assign(appSettings, {
    env: config.REACT_APP_ENV,
    OIDC_PROVIDER: config.REACT_APP_TEST_OIDC_PROVIDER,
    OIDC_CLIENT_ID: config.REACT_APP_TEST_OIDC_CLIENT_ID,
    OIDC_REDIRECT_ROUTE: config.REACT_APP_TEST_OIDC_REDIRECT_ROUTE,
    OIDC_END_SESSION_ENDPOINT: config.REACT_APP_TEST_OIDC_END_SESSION_ENDPOINT,
    API_BASE_URL: config.REACT_APP_TEST_API_BASE_URL,
    APIM_BASE_URL: config.REACT_APP_TEST_APIM_BASE_URL,
    OCP_APIM_SUBSCRIPTION_KEY: config.REACT_APP_TEST_OCP_APIM_SUBSCRIPTION_KEY,
    INSTRUMENTATION_KEY: config.REACT_APP_TEST_INSTRUMENTATION_KEY,
    WORKSPACE_ID: config.REACT_APP_TEST_WORKSPACE_ID,
    INSIGHTS_APP_ID: config.REACT_APP_TEST_INSIGHTS_APP_ID,
    INSIGHTS_API_KEY: config.REACT_APP_TEST_INSIGHTS_API_KEY,
    HARNESSKEY: config.REACT_APP_TEST_HARNESSKEY,
  });
}

// QA
else if (config.REACT_APP_ENV === "QA") {
  Object.assign(appSettings, {
    env: config.REACT_APP_ENV,
    OIDC_PROVIDER: config.REACT_APP_QA_OIDC_PROVIDER,
    OIDC_CLIENT_ID: config.REACT_APP_QA_OIDC_CLIENT_ID,
    OIDC_REDIRECT_ROUTE: config.REACT_APP_QA_OIDC_REDIRECT_ROUTE,
    OIDC_END_SESSION_ENDPOINT: config.REACT_APP_QA_OIDC_END_SESSION_ENDPOINT,
    API_BASE_URL: config.REACT_APP_QA_API_BASE_URL,
    APIM_BASE_URL: config.REACT_APP_QA_APIM_BASE_URL,
    OCP_APIM_SUBSCRIPTION_KEY: config.REACT_APP_QA_OCP_APIM_SUBSCRIPTION_KEY,
    INSTRUMENTATION_KEY: config.REACT_APP_QA_INSTRUMENTATION_KEY,
    WORKSPACE_ID: config.REACT_APP_QA_WORKSPACE_ID,
    INSIGHTS_APP_ID: config.REACT_APP_QA_INSIGHTS_APP_ID,
    INSIGHTS_API_KEY: config.REACT_APP_QA_INSIGHTS_API_KEY,
    HARNESSKEY: config.REACT_APP_QA_HARNESSKEY,
  });
}

// PROD
else if (config.REACT_APP_ENV === "PROD") {
  Object.assign(appSettings, {
    env: config.REACT_APP_ENV,
    OIDC_PROVIDER: config.REACT_APP_PROD_OIDC_PROVIDER,
    OIDC_CLIENT_ID: config.REACT_APP_PROD_OIDC_CLIENT_ID,
    OIDC_REDIRECT_ROUTE: config.REACT_APP_PROD_OIDC_REDIRECT_ROUTE,
    OIDC_END_SESSION_ENDPOINT: config.REACT_APP_PROD_OIDC_END_SESSION_ENDPOINT,
    API_BASE_URL: config.REACT_APP_PROD_API_BASE_URL,
    APIM_BASE_URL: config.REACT_APP_PROD_APIM_BASE_URL,
    OCP_APIM_SUBSCRIPTION_KEY: config.REACT_APP_PROD_OCP_APIM_SUBSCRIPTION_KEY,
    INSTRUMENTATION_KEY: config.REACT_APP_PROD_INSTRUMENTATION_KEY,
    WORKSPACE_ID: config.REACT_APP_PROD_WORKSPACE_ID,
    INSIGHTS_APP_ID: config.REACT_APP_PROD_INSIGHTS_APP_ID,
    INSIGHTS_API_KEY: config.REACT_APP_PROD_INSIGHTS_API_KEY,
    HARNESSKEY: config.REACT_APP_PROD_HARNESSKEY,
  });
}

// In production builds (containers), env-config.js runtime values override build-time values.
// In local dev (npm start), build-time .env.development values are used as-is.
if (process.env.NODE_ENV === 'production') {
  Object.keys(runtimeConfig).forEach((key) => {
    if (runtimeConfig[key] !== undefined && runtimeConfig[key] !== '' && key in appSettings) {
      // @ts-ignore
      appSettings[key] = runtimeConfig[key];
    }
  });
}

console.log('[appSettings] NODE_ENV:', process.env.NODE_ENV);
console.log('[appSettings] env:', appSettings.env);
console.log('[appSettings] API_BASE_URL:', appSettings.API_BASE_URL);
console.log('[appSettings] APIM_BASE_URL:', appSettings.APIM_BASE_URL);
console.log('[appSettings] OIDC_PROVIDER:', appSettings.OIDC_PROVIDER);

export { appSettings };
